import { User } from '@paragon/contract-library';
import { sealingService } from '@paragon/data-connections';
import { hasSealsAndSignaturesPermission } from '@paragon/login-tools';
import { addSpinnerMessage, removeSpinnerMessage } from '@paragon/task-spinner';

import { setSealsAndSignaturesData } from '../store/sealsAndSignaturesSlice';
import { loadOrganization, loadOrganizationsAsRoot } from './organizationActions';
import { AsyncThunkActionVoid, ThunkActionVoid } from './thunkActions';
import { loadAllUsersAsRoot, loadUser } from './userActions';

export const loadAdditionalInformationBasedOnPermissions =
  (user: User): ThunkActionVoid =>
  (dispatch, getState) => {
    if (hasSealsAndSignaturesPermission(getState())) {
      dispatch(loadSealsAndSignaturesData(user.email));
    }

    if (user.permissions.includes('root')) {
      dispatch(loadAllUsersAsRoot());
      dispatch(loadOrganizationsAsRoot());
    } else {
      dispatch(loadOrganization(user.organization));
    }
  };

const loadSealsAndSignaturesData =
  (userEmail: string): AsyncThunkActionVoid =>
  async (dispatch) => {
    const spinnerId = dispatch(addSpinnerMessage('Loading Seals & Signatures Data'));

    const getRegions = sealingService.regions.fetch();
    const getSeals = sealingService.seals.fetch(userEmail);
    const getSignatures = sealingService.signatures.fetch(userEmail);

    let results;
    try {
      results = await Promise.all([getRegions, getSeals, getSignatures]);
    } finally {
      dispatch(removeSpinnerMessage(spinnerId));
    }

    const sealsAndSignaturesData = {
      regions: results[0],
      seals: results[1],
      signatures: results[2],
    };
    dispatch(setSealsAndSignaturesData(sealsAndSignaturesData));
  };

export const logInSuccessFollowUp =
  (loadedUser: User): ThunkActionVoid =>
  (dispatch) => {
    dispatch(loadUser(loadedUser.email));
    dispatch(loadAdditionalInformationBasedOnPermissions(loadedUser));
  };
